/**
 * Media 컴포넌트
 * @description 이미지가 놓일 자리를 비율로 확보한다. 폭은 부모를 채우고 높이는 비율로
 *   결정된다. 이미지 로딩·리사이즈·플레이스홀더는 호출부가 넣는 내용의 몫이다. 앱 DS
 *   `Media` 의 웹 포팅.
 * @example
 * <Media ratio='square' slot={<AppImage uri={post.thumbnailUrl} />} />
 */
import { memo } from "react";

import { mediaStyles } from "./Media.styles";
import type { MediaProps } from "./Media.types";

const Media = memo<MediaProps>(({ ratio, slot, testID }) => (
  <div className={mediaStyles({ ratio })} data-testid={testID}>
    {slot}
  </div>
));

Media.displayName = "Media";

export default Media;
